import { render, staticRenderFns } from "./WebRequestDetailInquiry.vue?vue&type=template&id=a986f110&scoped=true&"
import script from "./WebRequestDetailInquiry.vue?vue&type=script&lang=js&"
export * from "./WebRequestDetailInquiry.vue?vue&type=script&lang=js&"
import style0 from "./WebRequestDetailInquiry.vue?vue&type=style&index=0&id=a986f110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a986f110",
  null
  
)

export default component.exports